<template>
    <!--评论榜-->
    <div class="wrapper">
        <div class="complain">
            <div class="head">
                <img style="width:380px;height:45px;" src="../assets/image/椭圆.png" alt="">
                <span v-text="'评论榜'"></span>
                <router-link class="more" :to="{path:'/ComplainView',query:{id:type,title:title}}" v-if="more"><span>MORE></span>
                </router-link>
            </div>
            <div class="rank-list">
                <ul>
                    <router-link class="title" tag="li" v-for="(item,index) in list" :key="index" :to="{ path: 'complainInfo',query:{id:item.id,cate:title}}">
                        <span class="number">{{index+1}}</span>
                        {{item.title}}
                    </router-link>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "CommentRank",
    props: {
        more: {
            type: Boolean,
            default: true
        },
        list: {
            type: [Array, String], //接收到的新闻数据
            default: () => {}
        },
        type: {
            type: Number,
            default: 0,
        },
        title: {
            type: String,
            default: '',
        }
    },
    data() {
        return {}
    },
    mounted() {

    }
}
</script>
<style scoped lang="less">
ul,
li {
    list-style: none;
}

.wrapper {
    width: 380px;
    height: 334px;
    border: 1px solid #bbb;
}

.head {
    display: flex;
    width: 380px;
    height: 42px;
    justify-content: space-between;
    border-bottom: 3px solid #ce1c24;
    position: relative;

    span {
        display: inline-block;
        position: absolute;
        width: 67px;
        height: 18px;
        font-size: 20px;
        font-family: JZhongYi;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 48px;
        margin: 0 17px;
    }

    .more {
        position: absolute;
        right: 95px;

        span {
            color: #ce1c24;
            font-size: 16px;
        }
    }
}

.rank-list {
    padding: 20px 20px 20px 0;

    .title {
        margin: 8px 16px;
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        cursor: pointer;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }
}

.number {
    display: inline-block;
    margin-right: 20px;
    width: 16px;
    height: 16px;
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 16px;
    background: #d0021b;
    text-align: center;
}
</style>